<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<nav
  [ngClass]="login && login.contraste ? 'navbar fixed-top navbar-expand-lg navbar-dark bg-dark' : 'navbar fixed-top navbar-expand-lg box-shadow bg-primary'">
  <a class="navbar-brand" routerLink="/transparencia/portal" *ngIf="login && login.orgao !== null">
    <div class="row">
      <div class="col-2">
        <img [src]="login.brasao" alt="" width="44" height="44"/>
      </div>
      <div class="col-2 mt-2">
        <p class="titulo-normal">{{login.orgao.nome}}</p>
        <p class="subtitulo-normal">
          PORTAL TRANSPARÊNCIA PÚBLICA
        </p>
      </div>
    </div>
  </a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <a class="navbar-brand" href="#"></a>
    <ul class="navbar-nav mr-auto">
      <li class="nav-item nv-width" style="width: 4vw;"><span>&nbsp;</span></li>
      <li class="nav-item active">
        <div class="input-group ">
          <input type="text" class="form-control" [(ngModel)]="filtro" (keydown.enter)="pesquisar()"
            [ngClass]="login && login.contraste ? 'form-control-contraste' : 'form-control-normal'"
            placeholder="Informe o que deseja localizar" aria-label="Localizar" aria-describedby="button-addon2">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" (click)="pesquisar()" type="button"
              [ngClass]="login && login.contraste ? 'button-contraste' : 'button-normal'" id="button-addon2">
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </li>
    </ul>

    <form class="form-inline my-2 my-lg-0 ml-4">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item dropdown ml-2">
          <button type="button" class="btn btn-link m-0 p-0" (click)="fonteNormal()">
            <img src="assets/img/normal.png" alt="" width="24" height="24">
          </button>
        </li>
        <li class="nav-item dropdown ml-2">
          <button type="button" class="btn btn-link m-0 p-0" (click)="fonte('a')">
            <img src="assets/img/mais.png" alt="" width="24" height="24">
          </button>
        </li>
        <li class="nav-item dropdown ml-2">
          <button type="button" class="btn btn-link m-0 p-0" (click)="fonte('d')">
            <img src="assets/img/menos.png" alt="" width="24" height="24">
          </button>
        </li>
        <li class="nav-item dropdown ml-3">
          <button class="btn btn-link m-0 p-0" (click)="btnContraste()">
            <img src="assets/img/contraste.png" alt="" width="24" height="24">
          </button>
        </li>
        <li class="nav-item dropdown ml-4">
          <button type="button" class="btn btn-link m-0 p-0"
            [routerLink]="['admin/transparencia/parametros-transparencia']" title="Login">
            <img src="assets/img/auth.png" alt="" height="24">
          </button>
        </li>
        <li class="nav-item dropdown ml-3">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false" style="padding-top: 2px; color: #ffffff;">
            <img src="assets/img/ajuda.png" alt="" width="24" height="24">
          </a>
          <div class="dropdown-menu  dropdown-menu-right" aria-labelledby="navbarDropdown">
            <a class="dropdown-item" [routerLink]="['transparencia/ajuda/ajuda']">Ajuda ao usuário</a>
            <a class="dropdown-item" [routerLink]="['/transparencia/ajuda/glossario']">Glossário</a>
          </div>
        </li>
      </ul>
    </form>
  </div>
</nav>
